export default `float e,s;
  p.y-=p.z*.6;
  e=p.y-tanh(abs(p.x+sin(p.z)*.5));
  for(s=2.;s<1e3;s+=s)
    p.xz*=rotate2D(s),
    e+=abs(dot(sin(p.xz*s),vec2(1.0)/s/4.));
  e=min(e,p.y)-1.3;
  return e;
}`